import "video.js/dist/video-js.css"
import "./index.js"; import "./vjs-plato-video-skin"
